export default __webpack_public_path__ + "static/blog-5-831158ecab78ee4c47a6170a473ac6c6.jpg";